<template>
    <div style="width: 100%; height: 100%" id="naver-map">
        <div ref="mapDiv" style="width: 100%; height: 100%"></div>
        <div class="map_btn_refresh" @click.prevent="initMap">초기화</div>
    </div>
</template>

<script>
import { $_WC, $_NM } from '@/confs/common.const.js';
import commonApi from '@/apis/common.api.js';

export default {
    name: 'NaverMap',
    props: {
        propOptions: {},
        propAddongCd: "",
        isShowZoomCtrl: {
            type: Boolean,
            default: true,
        },
        isShowAdSelector: {
            type: Boolean,
            default: true,
        },
        isSatelliteSelector: {
            type: Boolean,
            default: true,
        },
        zoomLevel: {
            type: Number,
            default: $_NM.ZOOM_LEVEL,
        },
        tileSizeScale: {
            type: Number,
            default: $_NM.TILE_SIZE_SCALE,
        },
    },
    data() {
        return {
            guCode: $_WC.adGuCode,
            map: {},
            options: {},
            mapTileSize: $_NM.TILE_SIZE * this.tileSizeScale,
            mapTypeId: naver.maps.MapTypeId.NORMAL,
            addongList: [],
            selectedAddongCd: $_WC.adGuCode,
            isMounted: false,
        };
    },
    watch: {
        propAddongCd: {
            immediate: false,
            handler(newVal, oldVal) {
                this.selectedAddongCd = newVal;
                this.moveMapAddong(this.selectedAddongCd);
            }
        }
    },
    computed: {
        Map_TYPE_NORMAL() {
            return naver.maps.MapTypeId.NORMAL;
        },
        Map_TYPE_SATELLITE() {
            return naver.maps.MapTypeId.SATELLITE;
        },
        addongMap() {
            let dongMap = {};
            for(let i in this.addongList) {
                dongMap[this.addongList[i].addongCd] = this.addongList[i];
            }
            return dongMap;
        }
    },
    created() {
        // 동 목록 불러오기 구현
        commonApi.fetchSubAddongList(this.selectedAddongCd)
            .then(res => {
                // 가나다 순 정렬
                let subAdAreaList = res.data.data.sort((pre, cur) => {
                    return pre.kostatAddongKorNm < cur.kostatAddongKorNm ? -1 : pre.kostatAddongKorNm > cur.kostatAddongKorNm ? 1: 0;
                });

                let tmp = {};
                subAdAreaList.forEach((d) => {
                    if(typeof tmp[d.kostatAddongCd] === 'undefined') {
                        tmp[d.kostatAddongCd] = {};
                        this.addongList.push(d);
                    }
                });
                // this.addongList = subAdAreaList;
                this.$eventBus.$emit('NaverMap::addong-list-loaded', subAdAreaList);
            });
    },
    mounted() {
        let defaultOptions = {
            lat: $_WC.localGovLatitude,      // 위도
            lng: $_WC.localGovLongitude,     // 경도
            // lat: 37.495408,      // 위도
            // lng: 127.060313,     // 경도
            zoom: this.zoomLevel,           // 지도의 초기 줌 레벨
            maxZoom: $_NM.MAX_ZOOM,                    // 지도의 최대 줌 레벨
            minZoom: $_NM.MIN_ZOOM,                     // 지도의 최소 줌 레벨
            zoomControl: false,             // 줌 컨트롤의 표시 여부
            zoomControlOptions: {
                // 줌 컨트롤의 옵션
                position: naver.maps.Position.TOP_RIGHT
            },
            mapTypeControl: false,  // 지도 타입 컨트롤러 사용여부 (위성/지도)
            scaleControl: false,    // 축적 표시여부
            mapDataControl: false   // 지도 데이터 유형 표시여부
        };

        if(typeof this.propOptions === $_WC.UNDEF) {
            this.options = defaultOptions;
        } else {
            this.options = jQuery.extend(true, defaultOptions, this.propOptions);
        }

        let tileSize = [this.mapTileSize, this.mapTileSize];
        let registry = new naver.maps.MapTypeRegistry();

        registry.set(this.Map_TYPE_NORMAL, naver.maps.NaverStyleMapTypeOption.getNormalMap({
            hd: true,
            tileSize: tileSize
        }));

        registry.set(this.Map_TYPE_SATELLITE, naver.maps.NaverStyleMapTypeOption.getSatelliteMap({
            hd: true,
            tileSize: tileSize
        }));

        this.map = new naver.maps.Map(this.$refs.mapDiv, {
            useStyleMap: true,
            center: new naver.maps.LatLng(this.options.lat, this.options.lng), //지도의 초기 중심 좌표
            zoomControl: this.options.zoomControl,
            zoom: this.options.zoom,
            mapTypeId: this.mapTypeId,
            mapTypes: registry
        });

        let listener = naver.maps.Event.addListener(this.map, 'tilesloaded', () => {
            naver.maps.Event.removeListener(listener);
            this.$eventBus.$emit('NaverMap::map-loaded', this.map);
        });

        naver.maps.Event.addListener(this.map, 'idle', () => {
            this.$eventBus.$emit('NaverMap::map-moved', this.map);
        });

        naver.maps.Event.addListener(this.map, 'click', () => {
            this.$eventBus.$emit('NaverMap::map-click', this.map);
        });
    },
    methods: {
        zoomIn() {
            let currZoom = this.map.getZoom();
            if(currZoom < this.options.maxZoom) {
                this.map.setZoom(currZoom + 1, true);
            }
        },
        zoomOut() {
            let currZoom = this.map.getZoom();
            if(currZoom > this.options.minZoom) this.map.setZoom(currZoom - 1, true);
        },
        changeMapType: function(mapTypeId) {
            if(this.map.getMapTypeId() !== mapTypeId) {
                this.mapTypeId = mapTypeId;
                this.map.setMapTypeId(mapTypeId);
            }
        },
        changeAddong(event) {
            event.preventDefault();
            this.moveMapAddong(this.selectedAddongCd);
            this.$eventBus.$emit("NaverMap::selected-addong-cd", addongCd);
        },
        moveMapAddong(addongCd) {
            let centerLat;
            let centerLng;

            if(addongCd !== $_WC.adGuCode && addongCd !== "" && typeof this.addongMap[addongCd] !== undefined) {
                centerLat = this.addongMap[addongCd].lttdVal;
                centerLng = this.addongMap[addongCd].lgtdVal;
            }else {
                centerLat = $_WC.localGovLatitude;
                centerLng = $_WC.localGovLongitude;
            }

            if(centerLat && centerLng) {
                this.map.setCenter(new naver.maps.LatLng(centerLat, centerLng));
            }

            if(addongCd === $_WC.adGuCode) {
                this.map.setZoom(this.zoomLevel);
            } else {
                this.map.setZoom($_WC.viewScale < 3 ? 13 : 15, true);
            }
        },
        initMap() {
            this.map.setCenter(new naver.maps.LatLng($_WC.localGovLatitude, $_WC.localGovLongitude));
            this.map.setZoom(this.zoomLevel);
            this.selectedAddongCd = $_WC.adGuCode;
            this.$eventBus.$emit("NaverMap::selected-addong-cd", $_WC.adGuCode);
        },
    },
}
</script>
